import {axiosApi} from "@/js/axios";

const state = {
    uxoTypes: [],
    uxoType: {},
    hazards: [],
    searchFilters: [],
    hazard: {},
    hazardsCount: 0,
    perPage: 28,

    // Flags
    fetchingUxoTypes: false,
    fetchingUxoType: false,
    fetchingHazards: false,
    fetchingHazard: false,
};

const getters = {
    pageCount: (state) => {
        return Math.ceil(state.hazardsCount / state.perPage);
    }
};

const actions = {
    fetchUxoTypes({commit}) {
        commit('SET_FETCHING_UXO_TYPES', true);

        return new Promise((resolve, reject) => {
            axiosApi.get(`/api/v2/hazard-types/top`)
                .then(({data}) => {
                    if (data) {
                        commit('SET_UXO_TYPES', data);
                        resolve(data.items)
                    }
                    commit('SET_FETCHING_UXO_TYPES', false);
                })
                .catch(error => {
                    commit('SET_FETCHING_UXO_TYPES', false);
                    reject(error);
                })
        });
    },
    fetchUxoType({commit}, payload) {
        commit('SET_FETCHING_UXO_TYPE', true);

        return new Promise((resolve, reject) => {
            axiosApi.get(`/api/v2/hazard-types/${payload.uxoTypeSlug}`)
                .then(({data}) => {
                    if (data) {
                        commit('SET_UXO_TYPE', data);
                        resolve(data.item)
                    }
                    commit('SET_FETCHING_UXO_TYPE', false);
                })
                .catch(error => {
                    commit('SET_FETCHING_UXO_TYPE', false);
                    reject(error);
                })
        });
    },
    fetchHazards({state, commit, dispatch}, payload) {
        commit('SET_FETCHING_HAZARDS', true);

        axiosApi.get(`/api/v2/hazards`, {
            params: {
                query: payload.filters.query ? payload.filters.query : '',
                typeId: state.uxoType.id,
                categoryId: payload.filters.category,
                originId: payload.filters.countryOfOrigin,
                useId: payload.filters.countryOfUse,
                width: payload.filters.width,
                height: payload.filters.height,
                dimensionUnit: payload.filters.dimensionUnit,
                weight: payload.filters.weight,
                weightUnit: payload.filters.weightUnit,
                orderBy: 'name',
                direction: 'ASC',
                page: payload.page ? payload.page : 1,
                perPage: state.perPage
            }
        }).then(({data}) => {
            if (data) {
                commit('SET_SEARCH_FILTERS', data);
                commit('SET_HAZARDS', data);
                commit('SET_HAZARDS_COUNT', data);
                resolve(data)
            }
            commit('SET_FETCHING_HAZARDS', false);
        }).catch(error => {
            commit('SET_FETCHING_HAZARDS', false);
            reject(error);
        })
    },
    fetchHazard({commit}, payload) {
        commit('SET_FETCHING_HAZARD', true);

        return new Promise((resolve, reject) => {
            axiosApi.get(`/api/v2/hazards/${payload.typeSlug}/${payload.slug}`)
                .then(({data}) => {
                    if (data) {
                        commit('SET_HAZARD', data);
                        resolve(data.item)
                    }
                    commit('SET_FETCHING_HAZARD', false);
                })
                .catch(error => {
                    commit('SET_FETCHING_HAZARD', false);
                    reject(error);
                })
        });
    },
};

const mutations = {
    SET_UXO_TYPES(state, data) {
        state.uxoTypes = data.items;
    },
    SET_UXO_TYPE(state, data) {
        state.uxoType = data.item;
    },
    SET_SEARCH_FILTERS(state, data) {
        state.searchFilters = data.filters;
    },
    SET_HAZARDS(state, data) {
        state.hazards = data.items.data;
    },
    SET_HAZARD(state, data) {
        state.hazard = data.item;
    },
    SET_HAZARDS_COUNT(state, data) {
        state.hazardsCount = data.items.total;
    },
    SET_FETCHING_UXO_TYPES(state, value) {
        state.fetchingUxoTypes = value;
    },
    SET_FETCHING_UXO_TYPE(state, value) {
        state.fetchingUxoType = value;
    },
    SET_FETCHING_HAZARDS(state, value) {
        state.fetchingHazards = value;
    },
    SET_FETCHING_HAZARD(state, value) {
        state.fetchingHazard = value;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/hazards.js